module.exports = __webpack_public_path__ + "static/media/bg.01c5cdc5.jpg";